// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.accounting.feeschedule.FeeScheduleItemProductResponse */
/* istanbul ignore next */
@GandalfModel
export class FeeScheduleItemProductResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	code!: string;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	locationProductId!: number;

	@GandalfProperty({ designType: String })
	manufacturer!: string;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	maximumAllowable!: number | null;

	@GandalfProperty({ designType: String })
	model!: string;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	usualAndCustomaryFee!: number;

}
